import React, { useEffect } from "react";
import { getPrintContent } from "../../PrintStore"; 
import "./PrintAll.css";

const Print = () => {
  const content = getPrintContent();

  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 300);
  }, []);

  if (!content) return <h2>No content to print</h2>;

  return <div className="print-area">{content}</div>;
};

export default Print;
